// src/services/city.service.ts
import api from './api';

// Get city dropdown by state (public)
export const getCityDropdown = async (stateId: string = "", cityId: string = "") => {
  const response = await api.post("/city/getAll", {
    StateID: stateId,
    CityID: cityId,
  });
  return response.data.data; // array of { ID, CityName, ... }
};